import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { User } from '@ps/auth-data-access';
import {
  DashboardPreference,
  DashboardPreferenceParams,
  ReportPreference,
} from '@ps/user-settings-models';

import { PersistUserSettings } from '../models/user-settings-persist.model';
import {
  UserSettingsActions,
  DashboardActions,
  DashboardApiActions,
  ReportPreferenceActions,
  BillingRulesActions,
} from './user-settings.actions';
import { Nullable } from '@ps/utils';

@Injectable({ providedIn: 'root' })
export class UserSettingsActionsFacade {
  private readonly _store = inject(Store);

  public load(user: User): void {
    this._store.dispatch(UserSettingsActions.load({ user }));
  }

  public rehydrate(payload: PersistUserSettings): void {
    this._store.dispatch(UserSettingsActions.rehydrate(payload));
  }

  public loadPreferences(params: DashboardPreferenceParams): void {
    this._store.dispatch(DashboardActions.loadPreferences({ params }));
  }

  public invalidatePreferencesCache(): void {
    this._store.dispatch(DashboardActions.invalidateCache());
  }

  public updatePreferences(preferences: DashboardPreference[]): void {
    this._store.dispatch(
      DashboardApiActions.updatePreferences({ preferences }),
    );
  }

  public loadReportPreference(userId: number): void {
    this._store.dispatch(
      ReportPreferenceActions.loadReportPreference({ userId }),
    );
  }

  public saveReportPreference(
    userId: number,
    preferences: ReportPreference[],
  ): void {
    this._store.dispatch(
      ReportPreferenceActions.saveReportPreference({ userId, preferences }),
    );
  }

  public loadBillingRules(selectedBuyerId: Nullable<number>): void {
    this._store.dispatch(
      BillingRulesActions.loadBillingRules({ selectedBuyerId }),
    );
  }
}
